// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1075":"0edb937b","2643":"421bbd47","2794":"99b94328","4078":"c481ccaa","5009":"99b94328"}[chunkId] + ".chunk.css";
};